import React from 'react'
import SharedCircularProgress from '../../shared/icons/SharedCircularProgress'
import styles from '../../../constants/styles'

export const PageLoadingCircularProgress = (props) => (
  <SharedCircularProgress sx={{ color: styles.colors.ambassador }} {...props} />
)

export const ButtonLoadingCircularProgress = (props) => (
  <SharedCircularProgress
    sx={{ color: styles.colors.white }}
    size={20}
    {...props}
  />
)
